import { KontakteNav } from "@/pages/kontakte/KontakteNav";
import { KONTAKTE_CHILD_ITEMS } from "@/lib/kontakteNav";
import { Outlet } from "react-router-dom";

export function KontakteLayout() {
  return (
    <div className="eh-bestellwesen-page-shell">
      <KontakteNav items={KONTAKTE_CHILD_ITEMS} />
      <div className="eh-project-page-main">
        <Outlet />
      </div>
    </div>
  );
}
